import { Button, MobileStepper } from '@mui/material';
import React from 'react';
import BackArrow from './Resources/BackArrow.svg';
import './MobileView.css';

function UploadStep2({ setUploadStep, selectedFilters, setSelectedFilters,listOfTags }) {
  const handleTag = (item) => {

    const tempSelectedFilters = [...selectedFilters];

    const tagIndex = tempSelectedFilters.indexOf(item);

    if (tagIndex !== -1) {
      tempSelectedFilters.splice(tagIndex, 1); // Remove the tag
    } else {
      tempSelectedFilters.push(item); // Add the tag
    }
      setSelectedFilters(tempSelectedFilters);
  };

  const renderTag = (item) => (
    <span className="content-tag-span" 
    style={{ backgroundColor: selectedFilters.includes(item) ? 'var(--Dark, #222731)' : 'transparent', 
          color: selectedFilters.includes(item) ? '#FFFFFF' : '#222731' }} onClick={() => handleTag(item)}>
      {item}
    </span>
  );

  const handleOnClick = () => {
    setUploadStep(3);
  };

  return (
    <div className="step2-div">
      <div style={{ display: 'flex', gap: '10px', cursor: 'pointer' }} onClick={() => setUploadStep(1)}>
        <img src={BackArrow} alt="back-arrow" />
        <span className="back-btn">Back</span>
      </div>
      <div className="step2-div-2">
        <span className="div-2-span-2">Add Tags to Your Video</span>
        <span className="div-2-span-3 mt-3 px-[70px] box-border leading-4">
          Select at least one tag that relates to your content
        </span>
        <div className="step2-div-3">
        { <div
                className="step2-tag-list"
              >
                {listOfTags.map((tag) => (
                  (renderTag(tag?.title))
                ))}
              </div>}
        </div>
      </div>
      <div className="step2-footer">
        <Button
          className="upload-btn max-w-[300px]" 
          disabled={selectedFilters.length === 0}
          onClick={() => handleOnClick()}
        >
          Next
        </Button>
        <MobileStepper
          variant="dots"
          steps={3}
          position="static"
          activeStep={1}
          sx={{ maxWidth: 400, flexGrow: 1 }}
          className="step-2-mobile-stepper"
        />
      </div>
    </div>
  );
}

export default UploadStep2;
